//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AtmSection from '~/components/redesign/AtmSection'
import LearnSection from '~/components/redesign/LearnSection'
import HowSection from '~/components/redesign/HowSection'
import HowPicsSection from '~/components/redesign/HowPicsSection'
import ResultSection from '~/components/redesign/ResultSection'
import FormatSection from '~/components/redesign/FormatSection'
import SignupSection from '~/components/redesign/SignupSection'
import TeachersSection from '~/components/redesign/TeachersSection'
import FaqSection from '~/components/redesign/FaqSection'
import CoursesSection from '~/components/redesign/CoursesSection'

export default {
  name: 'AllSections',
  components: {
    AtmSection,
    LearnSection,
    HowSection,
    HowPicsSection,
    ResultSection,
    FormatSection,
    SignupSection,
    TeachersSection,
    FaqSection,
    CoursesSection,
  },
  props: {
    isGraphicDesign: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFrontend: {
      type: Boolean,
      required: false,
      default: false,
    },
    crmTags: {
      type: String,
      default: '',
      required: false,
    },
    crmPipeline: {
      type: String,
      default: '',
      required: false,
    },
    crmStatus: {
      type: String,
      default: '',
      required: false,
    },
  },
}
